import {
  Button,
  Col,
  Flex,
  Form,
  Radio,
  Row,
  Select,
  Table,
  Tag,
  Typography,
} from "antd";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import { colors } from "../../../../../../constants/colors";
import Spinner from "../../../../../common/spinner/Spinner";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import styles from "./ReferralCode.module.scss";

const ReferralCodeList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { tickets } = useSelector((state) => state.tickets);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: tickets?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* filter dependencies */
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  const [selectedFilterStatus, setSelectedFilterStatus] = useState("user");
  /* filter dependencies */

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);

  const handleGetTableData = useCallback(() => {
    dispatch(getSystemSettingsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterStatus]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.ReferralCode.refereePointsCredit"),
        dataIndex: "reward_for_referee_amount",
        key: "reward_for_referee_amount",
        render: (_, record) => (
          <p>{`${record?.reward_for_referee_amount} points`}</p>
        ),
      },
      {
        title: t("Modules.ReferralCode.referrerPointsCredit"),
        dataIndex: "reward_for_referrer_amount",
        key: "reward_for_referrer_amount",
        render: (_, record) => (
          <p>{`${record?.reward_for_referrer_amount} points`}</p>
        ),
      },
      {
        title: t("Modules.ReferralCode.maxAllowedReferee"),
        dataIndex: "max_referee_allowed",
        key: "max_referee_allowed",
      },
      {
        title: t("Modules.ReferralCode.rewardAfterThresholdReached"),
        dataIndex: "reward_after_threshold_reached",
        key: "reward_after_threshold_reached",
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  background: record?.referral_program_is_active
                    ? colors.lightTeal
                    : colors.lightPinkishRed,
                  color: record?.referral_program_is_active
                    ? colors.darkTeal
                    : colors.darkMaroon,
                }}
              >
                {record?.referral_program_is_active ? t("CommonUtils.active") : t("CommonUtils.inactive")}
              </Tag>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    <div className={styles.referralCodeContainer}>
      <Flex vertical gap="2rem">
        <Flex justify="space-between">
          <Flex gap="1rem">
            <Button
              type="default"
              shape="circle"
              size="small"
              icon={<ArrowLeftOutlined />}
              onClick={() =>
                navigate(baseRouteMakerForSuperAdmin(routes.REFERRAL_CODE))
              }
            />
            <Typography.Title level={2}>
              {t("Modules.Configuration.referralCodeConfig")}
            </Typography.Title>
          </Flex>
          <Radio.Group
            onChange={(event) => setSelectedFilterStatus(event.target.value)}
            value={selectedFilterStatus}
            options={[
              { label: t("Modules.Configuration.user"), value: "user" },
              {
                label: t("Modules.Configuration.serviceProvider"),
                value: "service_provider",
              },
            ]}
          />
        </Flex>

        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={[
              selectedFilterStatus === "user"
                ? systemSettings?.customer_referral_program_info
                : systemSettings?.organization_referral_program_info,
            ]}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default ReferralCodeList;
